import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  ListSubheader,
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  InputAdornment,
  Chip,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import { BsSearch } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { updateSnackbar } from "../../_redux/SnackbarSlice";
import * as _ser from "../../_redux/_services/ClientsSlice";
import * as _postingser from "../../_redux/_services/JobPostingSlice";
import * as _props from "../../_redux/_services/JobPostingSlice";
import * as _userser from "../../_redux/_services/UserManagerSlice";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import { placeholders, placeholdersKeyNames } from "../../constants/constants";
import "./GenerateTemplateStyles.css";
import getUserDetails, {
  getAttributes,
  GetUserId,
} from "../../_utilities/getUserInfo";
import { decrypt } from "../../_utilities/_encryptDecryptHelper";
import ApplicantsFooter from "../ApplicantsFooter/ApplicantsFooter";
import { safeJsonParse } from "../../_utilities/utilities";

const initialSnackbar = { type: "", message: "" };
const EMPTY_ARRAY = [];

const mailmeArray = [
  { id: 1, name: "YES" },
  { id: 2, name: "NO" },
];

const GenerateTemplateNew = ({
  isAssociatedProfile,
  applicantDetails,
  jobCode,
  documents = null,
  tempApplicant,
  applicantCodes = EMPTY_ARRAY,
  onReceiveProps,
  to = null,
  selectedJobId = null,
}) => {
  const [mail, setMail] = useState(null);
  const [mailTemplate, setMailTemplate] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [profileDetails, setProfileDetails] = useState({
    jobCode: "",
    jobTitle: "",
    candidateName: "",
    contactNumber: "",
    email: "",
  });
  const [jobCustomFeilds, setJobCustomFeilds] = useState("");
  const [clientCustomFeilds, setClientCustomFeilds] = useState("");
  const [customFields, setCustomFields] = useState("");
  const [customJobKeys, setCustomJobKeys] = useState("");
  const [customClientKeys, setCustomClientKeys] = useState("");
  const [getClients, setGetClients] = useState("");
  const [customApplicantKeys, setCustomApplicantKeys] = useState("");
  const [jobpostings, setJobpostings] = useState(null);
  const [selectJobCode, setSelectJobCode] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [jobDetails, setjobDetails] = useState(null);
  const [templateCustomKeys, setTemplateCustomKeys] = useState("");
  const [templateCustomValues, setTemplateCustomValues] = useState("");
  const [hiringManagers, setHiringManagers] = useState([]);
  const [managerMail, setManagerMail] = useState(null);
  const [ccList, setCCList] = useState("YES");
  const [templateHasLoop, setTemplateHasLoop] = useState(false);
  const [tableColumnData, setTableColumnData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [otherPlaceholdersDetails, setOtherPlaceholdersDetails] = useState([]);
  const [isGenerateTemp, setIsGenerateTemp] = useState(true);
  const [openApplicantsModal, setOpenApplicantsModal] = useState(false);
  const [jobLoading, setJobLoading] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);
  const [isManagerSet, setIsManagerSet] = useState(false);
  const [selectedTo, setSelectedTo] = useState([]);
  const [selectedCc, setSelectedCc] = useState([]);
  const [showCcField, setShowCcField] = useState(false);
  const [popupType, setPopupType] = useState("");
  const dispatch = useDispatch();
  const initalState = { data: null, message: "", isloader: true };

  const [currentTo, setCurrentTo] = useState(to);

  useEffect(() => {
    setCurrentTo(to);
  }, [to]);

  const selectedTemplateResponse = useSelector(
    (state) => state.GetEmailTemplatebyId.data,
  );
  const hiringMangerData = useSelector(
    (state) => state.GetClients.hiringMangerData,
  );
  const recruitersData = useSelector(
    (state) => state.GetManagerTeamlead.recruiter,
  );
  const getDetails = useSelector((state) => state.Jobpostingsbyid.data);
  const listofTemplates = useSelector((state) => state.GetEmailTemplates.data);
  const customFieldsResponse = useSelector((state) => state.CustomFields.data);
  const responseData = useSelector((state) => state.Listjobpostings.data);
  const ClientsData = useSelector((state) => state.GetClients.data);

  const { email, firstName, lastName, aliasName, phoneNumbers } = useSelector(
    (state) => state.Auth,
  );

  useEffect(() => {
    async function init() {
      if (isAssociatedProfile === true) {
        const url = window.location.pathname;
        const path = url.substring(url.lastIndexOf("/") + 1);
        const jobId = !isNaN(path) ? path : selectedJobId;
        if (jobId) {
          GetJobData(jobId);
        }
      }
      const userId = await GetUserId();
      dispatch(_userser.customFieldsAsync(userId));
      dispatch(_userser.getEmailTemplatesAsync(userId, to));
      dispatch(_props.getManagerTeamleadAsync(" ", userId));
    }
    init();
  }, []);

  useEffect(() => {
    setIsManagerSet(false);
  }, [hiringManagers]);

  useEffect(() => {
    if (customFieldsResponse && customFieldsResponse.length > 0) {
      const customfielddata = JSON.parse(JSON.stringify(customFieldsResponse));
      let posingsObj = [];
      let applicantCustomObj = [];
      let clientCustomObj = [];
      customfielddata.forEach((list, i) => {
        if (parseInt(list.moduleId) === 1) {
          if (list.fieldType === "custom") {
            let newObj = { id: i, name: list.fieldName };
            posingsObj.push(newObj);
          }
        } else if (parseInt(list.moduleId) === 2) {
          if (list.fieldType === "custom") {
            let newObj = { id: i, name: list.fieldName };
            applicantCustomObj.push(newObj);
          }
        } else if (parseInt(list.moduleId) === 3) {
          if (list.fieldType === "custom") {
            let newObj = { id: i, name: list.fieldName };
            clientCustomObj.push(newObj);
          }
        }
      });
      setCustomJobKeys(posingsObj);
      setCustomApplicantKeys(applicantCustomObj);
      setCustomClientKeys(clientCustomObj);
    }
  }, [customFieldsResponse, listofTemplates]);

  useEffect(() => {
    if (getDetails !== null && getDetails !== undefined && getDetails !== "") {
      let postingData = JSON.parse(JSON.stringify(getDetails));
      postingData.primarySkills = postingData.primarySkills.replace(/\n/g, ",");
      postingData.secondarySkills = postingData.secondarySkills.replace(
        /\n/g,
        ",",
      );
      postingData.jobDesc = postingData.jobDesc.replace(/\r\n\r\n,/g, ",");
      postingData.jobDescForSM = postingData.jobDescForSM.replace(/\n,/g, ",");
      postingData.location= postingData?.location ? postingData?.location : "";
      setjobDetails(postingData);
      dispatch(_props.jobpostingsbyidStartReducer({}));
      let modifyOtherDetails = [...otherPlaceholdersDetails];
      modifyOtherDetails.forEach((x) => {
        if (
          x.type === "JobOpenings" &&
          x.key === placeholdersKeyNames[x.name]
        ) {
          x.value = postingData[x.name.split("JobOpenings.")[1]];
        } else if (x.type === "JobOpenings") {
          x.value = "";
        } else if (x.type === "Clients") {
          x.value = postingData[x.name.split("Clients.")[1]];
        }
      });
      let customFieldsList = JSON.parse(getDetails.customFields);
      if (customFieldsList && customFieldsList.length > 0) {
        let customFieldsArray = [];
        customFieldsList.forEach((list, index) => {
          customFieldsArray.push({
            id: index,
            name: list.key,
            value: list.value,
          });
        });
        setJobCustomFeilds(customFieldsArray);
      }
      customFieldsList.forEach((list) => {
        modifyOtherDetails.forEach((x) => {
          if (x.type === "JobOpenings" && x.key === list.key) {
            x.value = list.value;
          }
        });
      });
      console.log("modifyOtherDetails bbbbbb", modifyOtherDetails);
      setOtherPlaceholdersDetails(modifyOtherDetails);
      if (postingData.clientId === undefined && currentTo === "clients") {
        onReceiveProps(
          false,
          "Please select client to send an email to hiring manager",
        );
      }
      if (postingData.clientId) {
        dispatch(_ser.getClientsAsync(postingData.clientId));
      } else {
        setGetClients("");
        setHiringManagers([]);
        setManagerMail(null);
        let clearedDetails = [...modifyOtherDetails];
        clearedDetails.forEach((x) => {
          if (x.type === "Clients") {
            x.value = "";
          }
        });
        setOtherPlaceholdersDetails(clearedDetails);
      }
    }
  }, [getDetails]);

  const GetJobData = (id) => {
    dispatch(_props.jobpostingsbyidAsync(id));
  };

  const resetOtherPlaceholdersDetails = () => {
    let modifyOtherDetails = [...otherPlaceholdersDetails];
    modifyOtherDetails.forEach((x) => {
      if (x.type === "JobOpenings" || x.type === "Clients") {
        x.value = "";
      }
    });
    setOtherPlaceholdersDetails(modifyOtherDetails);
  };

  const ccOptions = [
    ...(hiringManagers?.map((item) => ({
      ...item,
      group: "Hiring Manager",
      label:
        item.fullName ||
        `${item.firstName || ""} ${item.lastName || ""}`.trim() ||
        item.emailId ||
        "",
      value: item.emailId || item.email,
    })) || []),
    ...(recruitersData?.map((item) => ({
      ...item,
      group: "Recruiter",
      label:
        item.fullName ||
        `${item.firstName || ""} ${item.lastName || ""}`.trim() ||
        item.emailId ||
        "",
      value: item.emailId || item.email,
    })) || []),
  ];

  const getNameFromEmail = (email) => {
    if (
      applicantDetails &&
      (applicantDetails.emailId === email ||
        applicantDetails.email === email ||
        applicantDetails.Applicants?.emailId === email)
    ) {
      return (
        applicantDetails.fullName ||
        `${applicantDetails.Applicants?.firstName || ""} ${applicantDetails.Applicants?.lastName || ""}`.trim()
      );
    }
    const foundApp = applicantCodes?.find(
      (app) =>
        (app.emailId ||
          app.email ||
          app.emailID ||
          app.Email ||
          app.EmailId ||
          app.Applicants?.emailId) === email,
    );
    if (foundApp) {
      return (
        foundApp.fullName ||
        foundApp.Applicantname ||
        `${foundApp.firstName || ""} ${foundApp.lastName || ""}`.trim()
      );
    }
    const foundCc = ccOptions.find((item) => item.value === email);
    if (foundCc && foundCc.label && foundCc.label !== email) {
      return foundCc.label;
    }

    return "";
  };

  const handleChange = async (value, type) => {
    if (type === "Template" && value) {
      dispatch(_userser.getEmailTemplatebyIdStartReducer(initalState));
      if (!Boolean(isAssociatedProfile)) {
        // dispatch(_props.jobpostingsbyidStartReducer(initalState));
        // setSelectedTemplate(null);
        // setjobDetails(null);
        // resetOtherPlaceholdersDetails();
        setJobCustomFeilds("");
        // setCustomFields("");
      }
      setSearchValue("");
      setSelectJobCode(null);
      setTemplateCustomKeys([]);
      setTemplateHasLoop(false);
      setManagerMail(null);
      setMailTemplate(value);
      setIsManagerSet(false);
      setTableColumnData([]);
      setTableData([]);
      setOtherPlaceholdersDetails([]);
      setSelectedCc([]);
      setShowCcField(false);
      if (value?.to) {
        setCurrentTo(value.to);
      }
      const userId = await GetUserId();
      dispatch(_userser.getEmailTemplatebyIdAsync(userId, value.id));
    } else if (type === "hiringManagerEmailId") {
      setManagerMail(value);
      let modifyOtherDetails = [...otherPlaceholdersDetails];
      modifyOtherDetails.map((item) => {
        if (item.key === "Hiring Manager's E-mail ID") {
          item.value = value.emailId;
        } else if (item.key === "Hiring Manager's Name") {
          item.value = value.fullName;
        } else if (item.value?.includes("@{Clients.")) {
          item.value = "";
        }
      });
      console.log("modifyOtherDetails ccccccc", modifyOtherDetails);
      setOtherPlaceholdersDetails(modifyOtherDetails);
    }
  };

  useEffect(() => {
    const toEmails = [];
    if (currentTo === "clients") {
      if (managerMail?.emailId) {
        toEmails.push(managerMail.emailId);
      } else if (managerMail?.email) {
        toEmails.push(managerMail.email);
      }
    } else {
      if (applicantDetails) {
        const email =
          applicantDetails.emailId ||
          applicantDetails.email ||
          applicantDetails.Applicants?.emailId;
        if (email) toEmails.push(email);
      }
      if (applicantCodes?.length > 0) {
        applicantCodes.forEach((app) => {
          const email =
            app.emailId ||
            app.email ||
            app.emailID ||
            app.Email ||
            app.EmailId ||
            app.Applicants?.emailId;
          if (email) toEmails.push(email);
        });
      }
    }
    const uniqueEmails = [...new Set(toEmails)];
    setSelectedTo(uniqueEmails);
  }, [applicantDetails, applicantCodes, currentTo, managerMail]);

  useEffect(() => {
    if (applicantDetails || tempApplicant || applicantCodes.length > 0) {
      let applicantObj = {},
        customFieldsList = [];
      if (isAssociatedProfile === false) {
        applicantObj = {
          candidateName: applicantDetails?.fullName
            ? `${applicantDetails?.fullName}`
            : `${applicantDetails.Applicants.firstName} ${applicantDetails.Applicants.lastName}`,
          contactNumber:
            applicantDetails?.Applicants?.contactNumber ||
            applicantDetails?.contactNumber ||
            "",
          applicantCode:
            applicantDetails?.Applicants?.applicantCode ||
            applicantDetails?.applicantCode ||
            "",
          email:
            applicantDetails?.Applicants?.emailId ||
            applicantDetails?.emailId ||
            "",
          candidateStatus: applicantDetails?.candidateStatus || "",
          source: applicantDetails?.resumesource || "",
          certification: applicantDetails?.certification?.join(", ") || "",
          educationDetails: transformDataObjToArray(
            applicantDetails.educationDetails,
            "education",
          ),
          skillDetails: applicantDetails?.skillDetails
            ? applicantDetails?.skillDetails?.map((x) => x.name).join(", ")
            : "",
          yearsofExperience: applicantDetails?.totalExperience || "",
          location:
            applicantDetails?.Applicants?.location ||
            applicantDetails?.location ||
            "",
        };
        customFieldsList = JSON.parse(applicantDetails?.customFields || "[]");
      } else {
        let matches = jobCode.match(/\(([^)]+)\)/g);
        let splitJobcode = matches[matches.length - 1].replace(/[()]/g, "");
        tempApplicant =
          applicantCodes.length > 0 ? applicantCodes[0] : tempApplicant;
        applicantObj = {
          jobCode: splitJobcode,
          email: tempApplicant.emailId ? tempApplicant.emailId : "",
          applicantCode: tempApplicant.applicantCode
            ? tempApplicant.applicantCode
            : "",
          candidateName: tempApplicant.fullName
            ? tempApplicant.fullName
            : tempApplicant.Applicantname
              ? tempApplicant.Applicantname
              : tempApplicant.firstName + "" + tempApplicant.lastName,
          contactNumber: tempApplicant.contactNumber
            ? tempApplicant.contactNumber
            : tempApplicant.ContactNumber
              ? tempApplicant.ContactNumber
              : "",
          source: tempApplicant.resumesource
            ? tempApplicant.resumesource
            : tempApplicant.SourceFrom
              ? tempApplicant.SourceFrom
              : "",
          certification: tempApplicant.certification
            ? safeJsonParse(JSON.parse(tempApplicant.certification)).join(", ")
            : "",
          educationDetails: tempApplicant.educationDetails
            ? transformDataObjToArray(
                safeJsonParse(tempApplicant.educationDetails, "education"),
              )
            : "",
          skillDetails: tempApplicant?.skillDetails
            ? safeJsonParse(JSON.parse(tempApplicant?.skillDetails))
                ?.map((x) => x.name)
                .join(", ")
            : "",
          workExp: tempApplicant.workExp
            ? transformDataObjToArray(
                safeJsonParse(tempApplicant.workExp, "workExp"),
              )
            : "",
          yearsofExperience: tempApplicant.yearsofExperience
            ? tempApplicant.yearsofExperience
            : "",
          location: tempApplicant.location ? tempApplicant.location : "",
        };
        if (tempApplicant) {
          customFieldsList = safeJsonParse(
            JSON.parse(tempApplicant?.customFields || "[]"),
          );
        }
      }
      setProfileDetails(applicantObj);

      if (customFieldsList) {
        let customFieldsArray = [];
        const formattedFields = safeJsonParse(customFieldsList)?.map(
          (list) => ({
            name: list.key,
            value: Array.isArray(list.value)
              ? list.value.filter(Boolean).join(", ")
              : list.value || "",
          }),
        );
        setCustomFields(formattedFields);
      }
    }
  }, [applicantDetails, tempApplicant, applicantCodes]);

  useEffect(() => {
    if (ClientsData !== null && hiringMangerData) {
      let ClientData = JSON.parse(JSON.stringify(ClientsData));
      const clientInfo = Array.isArray(ClientData) ? ClientData[0] : ClientData;
      setGetClients(clientInfo);
      let customFieldsList = JSON.parse(clientInfo?.customFields || "[]");
      if (customFieldsList && customFieldsList.length > 0) {
        let customFieldsArray = [];
        customFieldsList.forEach((list, index) => {
          customFieldsArray.push({
            id: index,
            name: list.key,
            value: list.value,
          });
        });
        setClientCustomFeilds(customFieldsArray);
      }
      let modifyOtherDetails = [...otherPlaceholdersDetails];
      modifyOtherDetails.forEach((x) => {
        if (
          x.type === "Clients" &&
          x.key === placeholdersKeyNames[x.name] &&
          x.name !== "Clients.endClientName"
        ) {
          x.value = clientInfo[x.name.split("Clients.")[1]];
          if(x.name === "Clients.clientName"){
            x["isConfidential"] = jobDetails?.isClientConfidential ?? "";
          }
        } else if (x.type === "Clients" && x.name === "Clients.endClientName") {
          x.value = jobDetails?.endClientName ?? "";
          x["isConfidential"] = jobDetails?.isEndClientConfidential ?? "";
        }
      });
      console.log("modifyOtherDetails aaaaaa", modifyOtherDetails);
      console.log("jobDetails>>>", jobDetails);
      setOtherPlaceholdersDetails(modifyOtherDetails);
      if (hiringMangerData.length > 0) {
        setHiringManagers(hiringMangerData);
      }
      dispatch(_ser.getClientsStartReducer(initalState));
    }
  }, [ClientsData, hiringMangerData]);

  const transformDataObjToArray = (data, type) => {
    if (data?.length > 0) {
      if (type === "education") {
        let educationArray = [];
        data?.forEach((list) => {
          let Degree = list.degree ? list.degree + "," : "";
          let Organization = list.organization ? list.organization + "," : "";
          let Duration =
            list.startDate && list.endDate
              ? list.startDate + " - " + list.endDate
              : list.startDate
                ? list.startDate
                : list.endDate
                  ? list.endDate
                  : "";
          let value = Degree + Organization + Duration;
          educationArray.push(`<p>${value}</p>`);
        });
        return educationArray.join(" ");
      } else if (type === "workExp") {
        let workExpArray = [];
        data.forEach((list) => {
          let JobTitle = list.jobTitle ? list.jobTitle + "," : "";
          let Organization = list.organization ? list.organization + "," : "";
          let Duration =
            list.startDate && list.endDate
              ? list.startDate + " - " + list.endDate
              : list.startDate
                ? list.startDate
                : list.endDate
                  ? list.endDate
                  : "";
          let value = JobTitle + Organization + Duration;
          workExpArray.push(`<p>${value}</p>`);
        });
        return workExpArray.join(" ");
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  useEffect(() => {
    async function init() {
      if (isAssociatedProfile && jobCode && applicantCodes.length > 0) {
        let matches = jobCode.match(/\(([^)]+)\)/g);
        let splitJobcode = matches[matches.length - 1].replace(/[()]/g, "");
        setProfileDetails({
          jobCode: splitJobcode,
          candidateName:
            profileDetails.candidateName || applicantCodes[0].Applicantname,
          email: profileDetails.email || applicantCodes[0].emailId,
          jobTitle: profileDetails.jobTitle,
          contactNumber:
            profileDetails.contactNumber || applicantCodes[0].ContactNumber,
        });
      }
    }
    init();
  }, [isAssociatedProfile, jobCode, applicantCodes]);

  useEffect(() => {
    if (listofTemplates && listofTemplates.length > 0) {
      let templatesData = JSON.parse(JSON.stringify(listofTemplates));
      let templatesArray = { applicants: [], clients: [] };
      templatesData.forEach((list) => {
        if (list?.to === "applicants") {
          templatesArray.applicants.push({
            id: list.id,
            name: list.name,
            value: "",
            to: list.to,
            candidateResume: list.candidateResume,
            type: "Applicant",
          });
        } else if (list?.to === "clients") {
          templatesArray.clients.push({
            id: list.id,
            name: list.name,
            value: "",
            to: list.to,
            candidateResume: list.candidateResume,
            type: "Client",
          });
        }
      });
      setMail(templatesArray);
    } else {
      setMail(null);
    }
  }, [listofTemplates]);

  useEffect(() => {
    if (selectedTemplateResponse && selectedTemplateResponse.length > 0) {
      let selectedTemplateData = JSON.parse(
        JSON.stringify(selectedTemplateResponse),
      );
      setSelectedTemplate(selectedTemplateData);
      let adminCustomList = selectedTemplateData[0]?.customValues
        ? JSON.parse(selectedTemplateData[0]?.customValues)
        : [];
      if (adminCustomList && adminCustomList.length > 0) {
        let array = [];
        adminCustomList.map((list, i) => {
          let selectedTempBody = selectedTemplateData[0].emailBody;
          let isAdminList = selectedTempBody.includes(list);
          if (isAdminList) {
            array.push({ id: i + 1, name: list, value: "" });
          }
        });
        setTemplateCustomKeys(array);
      }
      // for preview template
      const templeBody = selectedTemplateData[0].emailBody;
      const subject = selectedTemplateData[0].subject;
      if (
        otherPlaceholdersDetails.length === 0 &&
        tableColumnData.length === 0 &&
        tableData.length === 0
      ) {
        const allPlaceholders = [...templeBody.matchAll(/@\{([^}]+)\}@/g)].map(
          (m) => m[1],
        );
        if (allPlaceholders.length > 0) {
          let applicantPlaceholders = [
            ...new Set(
              allPlaceholders.filter((p) => p.startsWith("Applicants.")),
            ),
          ];

          // Filter out custom applicant fields from table display
          // Only include standard applicant fields that have predefined names
          // applicantPlaceholders = applicantPlaceholders.filter(
          //   (p) => placeholdersKeyNames[p] !== undefined
          // );

          const otherPlaceholders = [
            ...new Set(allPlaceholders.filter((p) => !p.startsWith("Custom."))),
          ];
          if (otherPlaceholders.length > 0) {
            const otherDetails = otherPlaceholders
              .map((list, index) => {
                const { updateTemplateBody } = UpdatePlaceholderToActualData(
                  `@{${list}}@`,
                  subject,
                  applicantCodes.length > 0
                    ? applicantCodes[0]
                    : profileDetails,
                  false,
                );
                if (currentTo === "clients" && managerMail) {
                  if (
                    list !== "JobOpenings.jobCode" &&
                    list !== "JobOpenings.jobDesc" &&
                    list !== "JobOpenings.jobDescForSM" &&
                    list !== "JobOpenings.primarySkills" &&
                    list !== "JobOpenings.secondarySkills" &&
                    list !== "User.firstName" &&
                    list !== "User.lastName" &&
                    list !== "User.aliasName" &&
                    list !== "User.emailId" &&
                    list !== "User.phoneNumber"
                  ) {
                    return {
                      id: index,
                      key: placeholdersKeyNames[list] || list.split(".")[1],
                      value: updateTemplateBody,
                      name: list,
                      type: list.split(".")[0],
                    };
                  }
                } else {
                  if (
                    list !== "JobOpenings.jobCode" &&
                    list !== "JobOpenings.jobDesc" &&
                    list !== "JobOpenings.jobDescForSM" &&
                    list !== "JobOpenings.primarySkills" &&
                    list !== "JobOpenings.secondarySkills" &&
                    list !== "User.firstName" &&
                    list !== "User.lastName" &&
                    list !== "User.aliasName" &&
                    list !== "User.emailId" &&
                    list !== "User.phoneNumber"
                  ) {
                    return {
                      id: index,
                      key: placeholdersKeyNames[list] || list.split(".")[1],
                      value:
                        updateTemplateBody !== "undefined"
                          ? updateTemplateBody
                          : "",
                      name: list,
                      type: list.split(".")[0],
                      isConfidential: (list === "Clients.clientName") ? jobDetails?.isClientConfidential : (list === "Clients.endClientName") ? jobDetails?.isEndClientConfidential : '',
                    };
                  }
                  return undefined;
                }
              })
              .filter(Boolean);
            console.log("modifyOtherDetails dddddd", otherDetails);
            setOtherPlaceholdersDetails(otherDetails);
          }
          let columns = [];

          if (applicantPlaceholders.length > 0) {
            columns = applicantPlaceholders.map((list, index) => ({
              id: index,
              displayName: placeholdersKeyNames[list]
                ? placeholdersKeyNames[list]
                : list.split(".")[1],
              mappingName: list,
            }));
          }

          // Add Document Name column if candidateResume === 1 and sending to clients
          if (mailTemplate?.candidateResume === 1 && currentTo === "clients") {
            columns.push({
              id: applicantPlaceholders.length,
              displayName: "Document Name",
              mappingName: "documentName",
              tbodyClass: "",
            });
          }

          if (
            applicantPlaceholders.length > 0 ||
            (mailTemplate?.candidateResume === 1 && currentTo === "clients")
          ) {
            let rows = [];
            const selectedAssociatedApplicants = !applicantCodes?.length
              ? [profileDetails]
              : applicantCodes;
            selectedAssociatedApplicants?.forEach(
              (applicant, applicantIndex) => {
                const row = {};
                applicant["candidateName"] =
                  applicant?.Applicantname ??
                  applicant?.fullName ??
                  applicant?.candidateName;
                applicant["contactNumber"] =
                  applicant?.ContactNumber ?? applicant?.contactNumber;
                applicant["email"] = applicant?.emailId ?? applicant?.email;
                applicant["source"] =
                  applicant?.SourcedFrom ?? applicant?.source;
                applicant["candidateStatus"] = applicant?.status ?? "";
                applicant["Document Name"] = applicant?.docName ?? "";
                applicant["docfileType"] = applicant?.docfileType ?? "";
                applicantPlaceholders.forEach((list) => {
                  const { updateTemplateBody } = UpdatePlaceholderToActualData(
                    `@{${list}}@`,
                    subject,
                    applicant,
                    false,
                  );
                  row[list] = updateTemplateBody;
                });

                // Add Document Name data if candidateResume === 1 and sending to clients
                // if (mailTemplate?.candidateResume === 1 && currentTo === 'clients') {
                //   row['Document Name'] = applicant?.docName
                //     ? `${applicant?.docfileType || 'document'}: ${applicant?.docName}`
                //     : '';
                // }
                if (
                  mailTemplate?.candidateResume === 1 &&
                  currentTo === "clients"
                ) {
                  row["documentName"] = applicant?.docName || "";
                  row["fileType"] = applicant?.docfileType || "";
                }

                rows.push(row);
              },
            );
            setTableColumnData(columns);
            setTableData(rows);
          }
        }
      }
      if (selectedTemplateData[0].emailBody.includes("data-loop='looping'")) {
        setTemplateHasLoop(true);
      }
    }
  }, [selectedTemplateResponse, managerMail, applicantCodes, customFields]);

  useEffect(() => {
    if (selectedTemplate && templateHasLoop) {
      updateEmailbody(true);
    }
  }, [templateHasLoop]);

  const updateTableHandler = (selectedTemplate, subject, isLooping) => {
    if (selectedTemplate && templateHasLoop) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(selectedTemplate, "text/html");
      // ====== Handle <tr data-loop> ======
      const trRows = doc.querySelectorAll("tr[data-loop]");
      trRows.forEach((loopRow, rowIndex) => {
        const parentTable = loopRow.closest("table");
        const selectedAssociatedApplicants =
          applicantCodes.length === 0 ? [profileDetails] : applicantCodes;
        selectedAssociatedApplicants.forEach((applicant, applicantIndex) => {
          const newRow = loopRow.cloneNode(true);
          Array.from(newRow.querySelectorAll("td")).forEach((td, index) => {
            let input = td.textContent.trim();
            if (input.includes("@{JobOpenings.")) {
              const { updateTemplateBody } = UpdatePlaceholderToActualData(
                input,
                subject,
                applicant,
                isLooping,
              );
              td.textContent = updateTemplateBody || "";
            } else if (input.includes("@{Applicants.")) {
              applicant["candidateName"] =
                applicant?.Applicantname ?? applicant?.candidateName;
              applicant["contactNumber"] =
                applicant?.ContactNumber ?? applicant?.contactNumber;
              applicant["email"] = applicant?.emailId ?? applicant?.email;
              applicant["source"] = applicant?.SourcedFrom ?? applicant?.source;
              applicant["candidateStatus"] = applicant?.status ?? "";
              const { updateTemplateBody } = UpdatePlaceholderToActualData(
                input,
                subject,
                applicant,
                isLooping,
              );
              td.textContent = updateTemplateBody || "";
            } else if (input.includes("@{Clients.")) {
              const { updateTemplateBody } = UpdatePlaceholderToActualData(
                input,
                subject,
                applicant,
                isLooping,
              );
              td.textContent = updateTemplateBody || "";
            }
          });
          parentTable.querySelector("tbody").appendChild(newRow);
        });
        loopRow.remove();
      });

      // ====== Handle generic .loop-marker elements ======
      const loopMarkers = doc.querySelectorAll(".loop-marker");
      loopMarkers.forEach((marker, index) => {
        const parent = marker.parentElement;
        const selectedAssociatedApplicants =
          applicantCodes?.length === 0 ? [profileDetails] : applicantCodes;
        selectedAssociatedApplicants?.forEach((applicant, applicantIndex) => {
          const newEl = marker.cloneNode(true);
          let input = newEl.textContent.trim();
          if (input.includes("@{JobOpenings.")) {
            const { updateTemplateBody } = UpdatePlaceholderToActualData(
              input,
              subject,
              applicant,
              isLooping,
            );
            newEl.textContent = updateTemplateBody || "";
          } else if (input.includes("@{Applicants.")) {
            applicant["candidateName"] =
              applicant?.Applicantname ?? applicant?.candidateName;
            applicant["contactNumber"] =
              applicant?.ContactNumber ?? applicant?.contactNumber;
            applicant["email"] = applicant?.emailId ?? applicant?.email;
            applicant["source"] = applicant?.SourcedFrom ?? applicant?.source;
            applicant["candidateStatus"] = applicant?.status ?? "";
            const { updateTemplateBody } = UpdatePlaceholderToActualData(
              input,
              subject,
              applicant,
              isLooping,
            );
            newEl.textContent = updateTemplateBody || "";
          } else if (input.includes("@{Clients.")) {
            const { updateTemplateBody } = UpdatePlaceholderToActualData(
              input,
              subject,
              applicant,
              isLooping,
            );
            newEl.textContent = updateTemplateBody || "";
          }
          parent.insertBefore(newEl, marker.nextSibling);
        });
        marker.remove();
      });
      doc.querySelectorAll("tr[data-loop='looping']").forEach((tr) => {
        tr.removeAttribute("data-loop");
      });
      return doc.body.innerHTML;
    }
  };

  useEffect(() => {
    if (
      responseData &&
      (responseData?.rows?.length > 0 || responseData?.rows)
    ) {
      if (searchValue.trim().length < 3) {
        setJobpostings([]);
        setJobLoading(false);
        dispatch(_postingser.listjobpostingsStartReducer({}));
        return;
      }
      let myData = JSON.parse(JSON.stringify(responseData));
      setJobpostings(myData.rows || []);
      setJobLoading(false);
      dispatch(_postingser.listjobpostingsStartReducer({}));
    }
  }, [responseData, searchValue]);

  const onActionTemplate = async (type) => {
    if (type === "copy") {
      if (
        profileDetails.jobCode &&
        profileDetails.jobCode !== "" &&
        profileDetails.email !== "" &&
        profileDetails.candidateName !== "" &&
        (currentTo === "clients" ? managerMail : true)
      ) {
        if (templateCustomKeys.length === 0) {
          sendmailHandler();
        } else if (templateCustomKeys.length > 0) {
          if (templateCustomValues.length > 0) {
            let customValuesValidate = templateCustomValues.filter(
              (list) => list.value !== "",
            );
            if (templateCustomKeys.length == customValuesValidate.length) {
              sendmailHandler();
            } else {
              dispatch(
                updateSnackbar({
                  type: "error",
                  message: "All custom fields are required",
                }),
              );
            }
          } else {
            dispatch(
              updateSnackbar({
                type: "error",
                message: "All custom fields are required",
              }),
            );
          }
        }
      } else if (profileDetails.email === "") {
        dispatch(
          updateSnackbar({ type: "error", message: "Please enter E-mail" }),
        );
      } else if (profileDetails.candidateName === "") {
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Please enter Candidate name",
          }),
        );
      } else if (currentTo === "clients" && managerMail === null) {
        dispatch(
          updateSnackbar({
            type: "error",
            message: "Please select hiring manager",
          }),
        );
      } else {
        dispatch(updateSnackbar({ type: "error", message: "Select JobCode" }));
      }
    }
  };

  const getModuleFromUrl = () => {
    const url = window.location.pathname.toLowerCase();
    if (url.includes("/jobpostings")) {
      return "jobopening";
    } else if (url.includes("/applicants")) {
      return "applicants";
    } else if (url.includes("/projects")) {
      return "projects";
    }
    return "others";
  };

  const getModuleIdFromUrl = () => {
    const path = window.location.pathname.split("/").pop();
    const id = Number(path);
    if (!isNaN(id)) {
      return id;
    }
    else {
      const moduleType = getModuleFromUrl();
      switch (moduleType) {
        case "jobopening" :
          return jobDetails?.id
        case "applicants": 
        case "projects":
          return applicantDetails?.id
        default :
          return null
      }
    }
  };

  const sendmailHandler = async () => {
    const clientId = getClients.id ? getClients.id : "0";
    let customerId = await GetUserId();
    let getUserDetails = await getAttributes();
    let cc_emails = [...selectedCc]; //process.env.REACT_APP_ENVIRONMENT_MODE === "DEV1" ? ["srilatha.n@tdqlabs.com", "hariprasad@tdqlabs.com"] : [...selectedCc];
    // if (ccList === "YES") {
    //   const myEmail =
    //     process.env.REACT_APP_ENVIRONMENT_MODE === "DEV1"
    //       ? "hariprasad@techdoquest.com"
    //       : getUserDetails[0].email;
    //   if (myEmail && !cc_emails.includes(myEmail)) {
    //     cc_emails.push(myEmail);
    //   }
    // }
    const final_cc_mail = cc_emails.length > 0 ? cc_emails.join(",") : "0";

    let Array = [];
    let obj = {};
    if (templateCustomValues.length > 0) {
      templateCustomValues.forEach((item) => {
        obj[item.name] = item.value;
      });
      Array.push(obj);
    }
    if (applicantCodes && applicantCodes.length > 1 && !templateHasLoop) {
      let data = {
        sender_mail: getUserDetails[0].email,
        jobId: jobDetails?.id,
        templateName: mailTemplate.name,
        templateId: mailTemplate.id,
        clientId: clientId,
        usercustomfields: Array,
        customerId: customerId,
        userId: getUserDetails[0].userId,
        firstName: getUserDetails[0].firstName,
        lastName: getUserDetails[0].lastName,
        source: "ATS",
        module: getModuleFromUrl(),
        moduleId: getModuleIdFromUrl(),
        cc_mail: final_cc_mail,
      };
      const applicantCodeArray = [];
      applicantCodes.forEach((item) => {
        applicantCodeArray.push(item.applicantCode);
      });
      if (currentTo === "clients") {
        data.applicantIds = applicantCodeArray;
        data.hiringManagerId = managerMail.id;
        data.receiver_mail =
          process.env.REACT_APP_ENVIRONMENT_MODE === "DEV1"
            ? "lavanya.modukuri@techdoquest.com"
            : managerMail.emailId;
        data.subject = selectedTemplate[0].subject;
        data.emailBody = selectedTemplate[0].emailBody;
        data.docId =
          mailTemplate?.candidateResume === 1 && applicantCodes.length > 0
            ? applicantCodes.map((x) => x.docsid)
            : mailTemplate?.candidateResume === 1 && profileDetails?.docsid
              ? [profileDetails?.docsid]
              : "0";
        dispatch(_userser.ClientBulkEmailAsync(data));
      } else {
        data.applicantIds = applicantCodeArray;
        data.subject = selectedTemplate[0].subject;
        data.emailBody = selectedTemplate[0].emailBody;
        dispatch(_userser.BulkEmailAsync(data));
      }
      onReceiveProps(false, "close");
    } else {
      onReceiveProps(false, "close");
      dispatch(updateSnackbar(initialSnackbar));
      let emailId = isAssociatedProfile
        ? tempApplicant.emailId
        : applicantDetails?.Applicants?.emailId || applicantDetails?.emailId;
      const applicantCodeArray = [];
      applicantCodes?.forEach((item) => {
        applicantCodeArray.push(item.applicantCode);
      });
      let data = {
        sender_mail: getUserDetails[0].email,
        subject: selectedTemplate[0].subject,
        emailBody: selectedTemplate[0].emailBody,
        userId: getUserDetails[0].userId,
        firstName: getUserDetails[0].firstName,
        lastName: getUserDetails[0].lastName,
        jobId: jobDetails?.id,
        templateName: mailTemplate.name,
        applicantIds: applicantDetails?.applicantCode
          ? [applicantDetails?.applicantCode]
          : tempApplicant?.applicantCode
            ? [tempApplicant?.applicantCode]
            : applicantCodeArray,
        aId: applicantDetails?.id ? applicantDetails?.id : "",
        docId:
          mailTemplate?.candidateResume === 1
            ? documents?.map((item) => item.docid)
            : "0",
        source: "ATS",
        module: getModuleFromUrl(),
        moduleId: getModuleIdFromUrl(),
        cc_mail: final_cc_mail,
        clientId: clientId,
        customerId: customerId,
        usercustomfields: Array,
      };
      if (currentTo === "clients") {
        data.receiver_mail =
          process.env.REACT_APP_ENVIRONMENT_MODE === "DEV1"
            ? "lavanya.modukuri@tdqlabs.com"
            : managerMail.emailId; //"shruti.reddy@tdqlabs.com"
      } else {
        data.receiver_mail =
          process.env.REACT_APP_ENVIRONMENT_MODE === "DEV1"
            ? "lavanya.modukuri@tdqlabs.com"
            : emailId; //"shruti.reddy@tdqlabs.com"
      }
      if (templateHasLoop) {
        data.applicantIds = applicantCodeArray;
        delete data.aId;
        delete data.docId;
        data.docId =
          mailTemplate?.candidateResume === 1 && applicantCodes.length > 0
            ? applicantCodes.map((x) => x.docsid)
            : mailTemplate?.candidateResume === 1 && profileDetails?.docsid
              ? [profileDetails?.docsid]
              : "0";
      }
      if (currentTo === "clients") {
        data.applicantIds = applicantCodeArray;
        data.hiringManagerId = managerMail.id;
        data.templateId = mailTemplate.id;
        dispatch(_userser.ClientBulkEmailAsync(data));
      } else {
        dispatch(_userser.BulkEmailAsync(data));
      }
    }
  };

  const onCustomfieldHandler = (value, key) => {
    let modifyObject = [...templateCustomKeys];
    modifyObject.find((x) => x.name === key.name).value = value;
    setTemplateCustomValues(modifyObject);
  };

  const updateEmailbody = (isLooping) => {
    let modifyTemple = JSON.parse(JSON.stringify(selectedTemplate));
    // assigned data
    let subject = modifyTemple[0].subject;
    let templeBody = modifyTemple[0].emailBody;
    // declaration
    let ApplicantKeys = [],
      JobKeys = [],
      ClientKeys = [],
      finalCustomKeys = [],
      appendJobCustomFeilds = [],
      appendApplicantCustomFeilds = [],
      appendClientCustomFeilds = [],
      appendTemplateCustomValues = [],
      mappingFields = [];
    if (customJobKeys.length > 0) {
      customJobKeys.map((list, index) => {
        JobKeys.push(`@{JobOpenings.${list.name}}@`);
        appendJobCustomFeilds.push({ id: index, name: list.name, value: "" });
      });
      if (!jobCustomFeilds || jobCustomFeilds.length === 0) {
        mappingFields = jobCustomFeilds
          ? jobCustomFeilds
          : appendJobCustomFeilds;
      }
      if (selectedTemplate !== "" && selectedTemplate) {
        JobKeys.forEach((list) => {
          if (templeBody.includes(list)) {
            let filterObj = mappingFields.filter(
              (x) => `@{JobOpenings.${x.name}}@` === list,
            );
            if (filterObj.length > 0) {
              templeBody.replace(list, filterObj[0].value);
            } else {
              templeBody.replace(new RegExp(list, "g"), "");
            }
          }
        });
      }
    }
    if (customApplicantKeys) {
      customApplicantKeys.map((list, index) => {
        ApplicantKeys.push(`@{Applicants.${list.name}}@`);
        appendApplicantCustomFeilds.push({
          id: index,
          name: list.name,
          value: "",
        });
      });
      if (!customFields || customFields.length === 0) {
        mappingFields = customFields
          ? customFields
          : appendApplicantCustomFeilds;
      }
      if (selectedTemplate !== "" && selectedTemplate) {
        ApplicantKeys.forEach((list) => {
          if (templeBody.includes(list)) {
            let filterObj = mappingFields.filter(
              (x) => `@{Applicants.${x.name}}@` === list,
            );
            if (filterObj.length > 0) {
              templeBody.replace(
                list,
                filterObj[0].value ? filterObj[0].value : "",
              );
            } else {
              templeBody.replace(new RegExp(list, "g"), "");
            }
          }
        });
      }
    }
    if (customClientKeys) {
      customClientKeys.map((list, index) => {
        ClientKeys.push(`@{Clients.${list.name}}@`);
        appendClientCustomFeilds.push({
          id: index,
          name: list.name,
          value: "",
        });
      });
      if (!clientCustomFeilds || clientCustomFeilds.length === 0) {
        mappingFields = clientCustomFeilds
          ? clientCustomFeilds
          : appendClientCustomFeilds;
      }
      if (selectedTemplate !== "" && selectedTemplate) {
        ClientKeys.forEach((list) => {
          if (templeBody.includes(list)) {
            let filterObj = mappingFields.filter(
              (x) => `@{Clients.${x.name}}@` === list,
            );
            if (filterObj.length > 0) {
              templeBody.replace(
                list,
                filterObj[0].value ? filterObj[0].value : "",
              );
            } else {
              templeBody.replace(new RegExp(list, "g"), "");
            }
          }
        });
      }
    }
    if (templateCustomKeys) {
      templateCustomKeys.map((list, index) => {
        finalCustomKeys.push(`@{Custom.${list.name}}@`);
        appendTemplateCustomValues.push({
          id: index,
          name: list.name,
          value: "",
        });
      });
      if (!templateCustomValues || templateCustomValues.length === 0) {
        mappingFields = templateCustomKeys
          ? templateCustomKeys
          : appendTemplateCustomValues;
      }
      if (selectedTemplate !== "" && selectedTemplate) {
        finalCustomKeys.forEach((list) => {
          if (templeBody.includes(list)) {
            let filterObj = mappingFields.filter(
              (x) => `@{Custom.${x.name}}@` === list,
            );
            if (filterObj.length > 0) {
              templeBody.replace(
                (list, "g"),
                filterObj[0].value ? filterObj[0].value : "",
              );
            } else {
              templeBody.replace(new RegExp(list, "g"), "");
            }
          }
        });
      }
    }
    if (isLooping) {
      templeBody = updateTableHandler(templeBody, subject, isLooping);
    }
    const { updateTemplateBody, updateSubject } = UpdatePlaceholderToActualData(
      templeBody,
      subject,
      profileDetails,
      isLooping,
    );
    modifyTemple[0].emailBody =
      !applicantCodes || applicantCodes.length === 1
        ? updateTemplateBody
        : modifyTemple[0].emailBody;
    modifyTemple[0].subject = updateSubject;
    setSelectedTemplate(modifyTemple);
  };

  const UpdatePlaceholderToActualData = (
    templeBody,
    subject,
    profileDetails,
    isLooping,
  ) => {
    let UserContact = "";

    if (phoneNumbers) {
      const userPhoneNumbers = JSON.parse(phoneNumbers);

      if (Array.isArray(userPhoneNumbers) && userPhoneNumbers.length > 0) {
        const selectCountryId = JSON.parse(decrypt("selectCountryId"));

        const currentPhoneNumber = userPhoneNumbers.filter(
          (x) => x.countryId === selectCountryId,
        );

        if (currentPhoneNumber.length > 0) {
          UserContact = currentPhoneNumber[0].phoneNumber;
        }
      }
    }

    let updateTemplateBody = "",
      updateSubject = "";
    updateTemplateBody = templeBody
      .replace(
        placeholders.APPLICANT,
        profileDetails?.candidateName ??
          profileDetails?.Applicantname ??
          profileDetails?.fullName ??
          "",
      )
      .replace(
        placeholders.CONTACTNUMBER,
        profileDetails?.contactNumber ?? profileDetails?.ContactNumber ?? "",
      )
      .replace(placeholders.JOBCODE, jobDetails?.jobCode)
      .replace(placeholders.JOBTITLE, jobDetails?.jobTitle)
      .replace(
        placeholders.EDUCATIONDETAILS,
        profileDetails?.educationDetails ?? "",
      )
      .replace(placeholders.APPLICANTCODE, profileDetails?.applicantCode ?? "")
      .replace(
        placeholders.EMAILID,
        profileDetails?.email ?? profileDetails?.emailId ?? "",
      )
      .replace(placeholders.SKILLDETAILS, profileDetails?.skillDetails ?? "")
      .replace(placeholders.CERTIFICATION, "") // profileDetails?.certification ?? ''
      .replace(placeholders.WORKEXP, "") // profileDetails?.workExp ?? ''
      .replace(placeholders.TOTALEXP, profileDetails?.yearsofExperience ?? "")
      .replace(placeholders.APPLICANTLOCATION, profileDetails?.location ?? "")
      .replace(
        placeholders.SOURCE,
        profileDetails?.source ?? profileDetails?.SourcedFrom ?? "",
      )
      .replace(
        placeholders.CANDIDATESTATUS,
        profileDetails?.candidateStatus ?? "",
      )
      .replace(placeholders.JOBSTATUS, jobDetails?.jobStatus)
      .replace(placeholders.LOCATION, jobDetails?.location)
      .replace(placeholders.JOBTYPE, jobDetails?.jobType)
      .replace(placeholders.PAYBILLRATE, jobDetails?.payBillRate)
      .replace(placeholders.PRIMARYSKILLS, jobDetails?.primarySkills)
      .replace(placeholders.WORKMODEL, jobDetails?.workModel)
      .replace(placeholders.JOBDESCFORSM, jobDetails?.jobDescForSM)
      .replace(placeholders.JOBDESC, jobDetails?.jobDesc)
      .replace(placeholders.SECONDARYSKILLS, jobDetails?.secondarySkills)
      .replace(placeholders.PRIORITY, jobDetails?.priority)
      .replace(placeholders.CLIENTNAME, jobDetails?.clientName ?? "")
      .replace(placeholders.ENDCLIENTNAME, jobDetails?.endClientName ?? "")
      .replace(placeholders.REGION, getClients?.region ?? "")
      .replace(
        placeholders.STATUS,
        getClients?.status
          ? getClients.status === "1"
            ? "Active"
            : "Inactive"
          : "",
      )
      .replace(placeholders.MANAGEREMAIL, getClients?.emailId ?? "")
      .replace(placeholders.HIRINGMANAGER, managerMail?.fullName ?? "")
      .replace(placeholders.HIRINGMANAGEREMAIL, managerMail?.emailId ?? "")
      .replace(placeholders.USERFIRSTNAME, firstName ?? "")
      .replace(placeholders.USERLASTNAME, lastName ?? "")
      .replace(placeholders.ALIASNAME, aliasName ?? "")
      .replace(placeholders.USEREMAILID, email ?? "")
      .replace(placeholders.USEREPHONENUMBER, UserContact ?? "");
    // Only apply global customFields when NOT processing multiple applicants
    // When processing multiple applicants from applicantCodes, each applicant should use their own customFields
    if (customFields.length > 0 && applicantCodes?.length <= 1) {
      //customFields
      customFields.forEach((list) => {
        updateTemplateBody = updateTemplateBody.replace(
          `@{Applicants.${list.name}}@`,
          list.value ?? "",
        );
      });
    }
    if (applicantCodes?.length > 0) {
      let applicantCustomfields = profileDetails?.customFields
        ? safeJsonParse(JSON.parse(profileDetails?.customFields))
        : [];
      if (applicantCustomfields?.length > 0) {
        applicantCustomfields.forEach((list) => {
          updateTemplateBody = updateTemplateBody.replace(
            `@{Applicants.${list.key}}@`,
            list.value ?? "",
          );
        });
      }
    }
    if (customApplicantKeys) {
      customApplicantKeys.forEach((list) => {
        updateTemplateBody = updateTemplateBody.replace(
          `@{Applicants.${list.name}}@`,
          list.value ?? "",
        );
      });
    }
    if (jobCustomFeilds.length > 0) {
      jobCustomFeilds.forEach((list) => {
        updateTemplateBody = updateTemplateBody.replace(
          `@{JobOpenings.${list.name}}@`,
          list.value ?? "",
        );
      });
    }
    if (customJobKeys.length > 0) {
      customJobKeys.forEach((list) => {
        updateTemplateBody = updateTemplateBody.replace(
          `@{JobOpenings.${list.name}}@`,
          list.value ?? "",
        );
      });
    }
    if (clientCustomFeilds.length > 0) {
      clientCustomFeilds.forEach((list) => {
        updateTemplateBody = updateTemplateBody.replace(
          `@{Clients.${list.name}}@`,
          list.value ?? "",
        );
      });
    }
    if (templateCustomKeys.length > 0 && !isLooping) {
      templateCustomKeys.forEach((list) => {
        updateTemplateBody = updateTemplateBody.replace(
          new RegExp(`@{Custom.${list.name}}@`, "g"),
          list.value ?? "",
        );
      });
    }
    if (templateCustomValues.length > 0 && !isLooping) {
      templateCustomValues.forEach((list) => {
        updateTemplateBody = updateTemplateBody.replace(
          new RegExp(`@{Custom.${list.name}}@`, "g"),
          list?.value ?? "",
        );
      });
    }
    updateSubject = subject
      .replace(placeholders.JOBTITLE, jobDetails?.jobTitle)
      .replace(placeholders.LOCATION, jobDetails?.location)
      .replace(placeholders.CLIENTNAME, jobDetails?.clientName ?? "")
      .replace(placeholders.ENDCLIENTNAME, jobDetails?.endClientName ?? "");
    return { updateTemplateBody, updateSubject };
  };

  const onChangeHandler = (value, type) => {
    let modifyObject = JSON.parse(JSON.stringify(profileDetails));
    modifyObject[type] = value;
    if (!Boolean(isAssociatedProfile)) {
      let myJobData = jobpostings?.filter((x) => x.jobCode === value);
      if (myJobData?.length > 0) {
        GetJobData(myJobData[0]?.id);
      }
    }
    setProfileDetails(modifyObject);
  };

  const CustomFieldsByModule = ({ data }) => (
    <>
      <tr>
        <td width="200px">
          <span style={{ wordBreak: "break-all" }}>{data.key}</span>
        </td>
        <td width="30px" align="center">
          :
        </td>
        {!data?.value?.includes("@{Clients.") && (
          <td width="400px">
            {Array.isArray(data.value) ? data.value.join(", ") : data.value}
          </td>
        )}
      </tr>
      {data?.isConfidential === 1 && data.name === "Clients.clientName" && (
        <tr>
          <td colSpan={3}>
            <p className="confidential-message">
              <img src={`${process.env.PUBLIC_URL}/assests/img/info-inline-icon.svg`} alt="" />
              This client is marked as confidential. Their name will not be included in the email.
            </p>
          </td>
        </tr>
      )}
      {data?.isConfidential === 1 && data.name === "Clients.endClientName" && (
        <tr>
          <td colSpan={3}>
            <p className="confidential-message">
              <img src={`${process.env.PUBLIC_URL}/assests/img/info-inline-icon.svg`} alt="" />
              This end client is marked as confidential. Their name will not be included in the email.
            </p>
          </td>
        </tr>
      )}
    </>
  );

  const footerHandler = (id, type) => {
    if (type === "Send E-mail") {
      onActionTemplate("copy");
    } else if (type === "Back") {
      setMailTemplate("");
      setSelectedCc([]);
      setShowCcField(false)
    }
  };

  useEffect(() => {
    if (
      otherPlaceholdersDetails.length > 0 &&
      hiringManagers.length === 1 &&
      !isManagerSet
    ) {
      handleChange(hiringManagers[0], "hiringManagerEmailId");
      setIsManagerSet(true);
    }
  }, [otherPlaceholdersDetails, hiringManagers, isManagerSet]);

  return (
    <>
      {mail && (mail?.applicants.length > 0 || mail?.clients.length > 0) ? (
        <div id="mailtemplatebody" style={{ marginTop: "0px" }}>
          <div style={{ width: "100%",minWidth: "620px" }}>
            <FormControl fullWidth autoComplete="off">
              <InputLabel className="boldSelectlabel">Template</InputLabel>
              <Select
                value={mailTemplate}
                name="Template"
                autoComplete="off"
                label="Template*&nbsp;&nbsp;&nbsp;"
                onChange={(e) => handleChange(e.target.value, "Template")}
                sx={{
                  '& .MuiSelect-select': {
                    wordBreak: 'break-word'
                  }
                }}
                renderValue={(selected) => {
                  if (!selected) return "";
                  return `${selected.type} - ${selected.name}`;
                }}
                style={{
                  width: "100%",
                  height: "3.5rem",
                  borderRadius: "4px",
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 460,
                      maxWidth: "600px",
                      "& .MuiMenuItem-root": {
                        // whiteSpace: "normal",
                        wordBreak: "break-word",
                      },
                    },
                  },
                }}
              >
                {mail && mail?.applicants.length > 0 && (
                  <ListSubheader className="listSubheader">
                    Applicant
                  </ListSubheader>
                )}
                {mail &&
                  mail?.applicants?.map((list) => (
                    <MenuItem
                      className="selectOptions"
                      key={list.id}
                      value={list}
                      sx={{
                        pl: 4,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      }}
                    >
                      <span></span>
                      {list.name}
                    </MenuItem>
                  ))}
                {mail && mail?.clients.length > 0 && (
                  <ListSubheader className="listSubheader">
                    Client
                  </ListSubheader>
                )}
                {mail &&
                  mail?.clients?.map((list) => (
                    <MenuItem
                      className="selectOptions"
                      key={list.id}
                      value={list}
                      sx={{
                        pl: 4,
                        wordBreak: "break-word",
                      }}
                    >
                      <span></span>
                      {list.name}
                    </MenuItem>
                  ))}
              </Select>
              {mailTemplate && (
                <span
                  style={{
                    position: "absolute",
                    right: "40px",
                    top: "18px",
                    zIndex: 1,
                    cursor: "pointer",
                    textDecoration: "underline",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setPopupType("Template");
                    setOpenPreview(true);
                  }}
                >
                  View Template
                </span>
              )}
            </FormControl>
          </div>

  
        <div>
          {mailTemplate ? (
            <>
              <div>
                <table className="send_mail_section">
                  <>
                    <tr>
                      <td colSpan={3}>
                        <p className="customheading">Job Information</p>
                      </td>
                    </tr>
                    <tr className="jobcode-label-row">
                      {Boolean(isAssociatedProfile) ? (
                        <td width="200px">Job Code</td>
                      ) : (
                        <td width="0px">Job</td>
                      )}
                      <td width="30px" align="center">
                        :
                      </td>
                      <td width="400px">
                        {Boolean(isAssociatedProfile) ? (
                          <TextField
                            id="outlined-basic"
                            disabled
                            size="small"
                            variant="outlined"
                            name="jobCode"
                            value={profileDetails.jobCode}
                          />
                        ) : (
                          <div
                            className="boldlabel custom-job-box"
                            style={{
                              display: "flex",
                              width: Boolean(!isAssociatedProfile)
                                ? "100%"
                                : "32%",
                            }}
                          >
                            <Autocomplete
                              options={jobpostings || []}
                              fullWidth={Boolean(!isAssociatedProfile)}
                              autoHighlight
                              id="job-autocomplete"
                              autoComplete="off"
                              clearOnEscape
                              loading={jobLoading}
                              value={selectJobCode}
                              inputValue={searchValue}
                              getOptionLabel={(option) =>
                                option?.jobCode
                                  ? `${option?.jobCode} - ${option?.jobTitle}`
                                  : ""
                              }
                              blurOnSelect={true}
                              onInputChange={(event, value, reason) => {
                                setSearchValue(value);
                                if (
                                  reason === "clear" ||
                                  value.trim().length < 3
                                ) {
                                  resetOtherPlaceholdersDetails();
                                  setJobLoading(false);
                                  setJobpostings([]);
                                  setjobDetails(null);
                                  return;
                                }
                                if (value.trim().length > 2) {
                                  setJobLoading(true);
                                  const delayDebounceFn = setTimeout(() => {
                                    let obj = { keyword: value.trim() };
                                    // setjobDetails(null);
                                    setJobpostings([]);
                                    dispatch(
                                      _postingser.listjobpostingsAsync(
                                        obj,
                                        "searchWithoutPaging",
                                      ),
                                    );
                                  }, 400);
                                  return () =>
                                    clearTimeout(delayDebounceFn);
                                }
                              }}
                              onChange={(e, value, reason) => {
                                if (reason === "clear") {
                                  setSelectJobCode(null);
                                  setSearchValue("");
                                  onChangeHandler("", "jobCode");
                                  setjobDetails(null);
                                  if (currentTo === "applicants") {
                                    setSelectedCc([]);
                                    setShowCcField(false);
                                  }
                                } else {
                                  setSelectJobCode(value);
                                  if (value?.jobCode) {
                                    setSearchValue(
                                      `${value.jobCode} - ${value.jobTitle}`,
                                    );
                                  }
                                  onChangeHandler(
                                    value?.jobCode,
                                    "jobCode",
                                  );
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  className="boldlabel custom-job-input"
                                  autoComplete="off"
                                  placeholder="Search by Jobcode, JobTitle"
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      const value = e.target.value.trim();
                                      if (
                                        value.length > 0 &&
                                        value.length < 3
                                      ) {
                                        dispatch(
                                          updateSnackbar({
                                            type: "error",
                                            message:
                                              "Required Minimum 3 Characters",
                                          }),
                                        );
                                      }
                                    }
                                  }}
                                  style={{
                                    width: Boolean(!isAssociatedProfile)
                                      ? "100%"
                                      : "198px",
                                  }}
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <BsSearch
                                          size={16}
                                          style={{
                                            color: "rgba(0, 0, 0, 0.54)",
                                          }}
                                        />
                                      </InputAdornment>
                                    ),
                                    endAdornment: (
                                      <InputAdornment
                                        position="end"
                                        sx={{ gap: 0.5 }}
                                      >
                                        {jobLoading && (
                                          <CircularProgress
                                            color="inherit"
                                            size={18}
                                          />
                                        )}
                                        {params.InputProps.endAdornment}
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              )}
                            />
                          </div>
                        )}
                      </td>
                    </tr>
                    {otherPlaceholdersDetails.length > 0 &&
                      otherPlaceholdersDetails.map((list) => {
                        if (list && list.type === "JobOpenings") {
                          return <CustomFieldsByModule data={list} />;
                        }
                      })}
                  </>
                  {/* ) : ( */}
                  {(currentTo === "clients" ||
                    (otherPlaceholdersDetails.length > 0 &&
                      otherPlaceholdersDetails.some(
                        (item) => item.type === "Clients",
                      ))) && (
                    <>
                      <tr>
                        <td colSpan={3}>
                          <p className="customheading">
                            Client Information
                          </p>
                        </td>
                      </tr>
                      {currentTo === "clients" && (
                        <tr>
                          <td width="200px">Hiring Manager</td>
                          <td width="30px" align="center">
                            :
                          </td>
                          <td>
                            <FormControl
                              fullWidth
                              autoComplete="off"
                              error={
                                hiringManagers.length === 0 &&
                                currentTo === "clients"
                              }
                            >
                              <Select
                                value={managerMail}
                                name="hiringManagerEmailId"
                                autoComplete="off"
                                onChange={(e) =>
                                  handleChange(
                                    e.target.value,
                                    "hiringManagerEmailId",
                                  )
                                }
                                className="managerDropdown"
                                displayEmpty
                                renderValue={(selected) => {
                                  if (selected === "" || !selected) {
                                    return <em>Select</em>;
                                  }
                                  return selected.fullName;
                                }}
                              >
                                {hiringManagers &&
                                  hiringManagers.map((list) => (
                                    <MenuItem
                                      className="selectOptions"
                                      key={list.id}
                                      value={list}
                                    >
                                      {list.fullName}
                                    </MenuItem>
                                  ))}
                              </Select>
                            </FormControl>
                          </td>
                        </tr>
                      )}
                      {hiringManagers.length === 0 &&
                      currentTo === "clients" ? (
                        <tr>
                          <td width="200px"></td>
                          <td width="30px" align="center"></td>
                          <td
                            style={{
                              color: "red",
                              position: "relative",
                              fontSize: "12px",
                              padding: "3px",
                            }}
                          >
                            <span
                              style={{
                                color: "red",
                                position: "relative",
                                fontSize: "12px",
                                padding: "3px",
                              }}
                            >
                              ❗
                            </span>{" "}
                            No Hiring Managers Available
                          </td>
                        </tr>
                      ) : (
                        ""
                      )}

                      {otherPlaceholdersDetails.length > 0 &&
                        otherPlaceholdersDetails.map((list) => {
                          if (list && list.type === "Clients") {
                            return <CustomFieldsByModule data={list} />;
                          }
                        })}
                    </>
                  )}

                  {(!templateHasLoop || templateHasLoop) &&
                  tableData.length > 0 ? (
                    <>
                      <tr>
                        <td width="200px">
                          <p className="customheading">
                            Applicant Information
                          </p>
                        </td>
                        <td width="30px" align="center">
                          {applicantCodes?.length > 1 && ":"}
                        </td>
                        <td width="400px">
                          {applicantCodes?.length > 1 && (
                            <span
                              className="viewAllApplicants"
                              onClick={() => setOpenApplicantsModal(true)}
                            >
                              View all {applicantCodes.length} applicants
                            </span>
                          )}
                        </td>
                      </tr>

                      {mailTemplate?.candidateResume === 1 &&
                        applicantCodes?.length === 1 &&
                        currentTo === "clients" && (
                          <tr>
                            <td width="200px">Document Name</td>

                            <td width="30px" align="center">
                              :
                            </td>

                            <td width="400px">
                              <div className="documentWrapper">
                                {applicantCodes[0]?.docfileType ===
                                  "pdf" && (
                                  <img
                                    src={`${process.env.PUBLIC_URL}/assests/img/pdf.svg`}
                                    alt="pdf"
                                    className="fileIcon"
                                  />
                                )}

                                {(applicantCodes[0]?.docfileType ===
                                  "docx" ||
                                  applicantCodes[0]?.docfileType ===
                                    "doc") && (
                                  <img
                                    src={`${process.env.PUBLIC_URL}/assests/img/docx.svg`}
                                    alt="docx"
                                    className="fileIcon"
                                  />
                                )}

                                <span className="documentName">
                                  {applicantCodes[0]?.docName}
                                </span>
                              </div>
                            </td>
                          </tr>
                        )}

                      {applicantCodes?.length <= 1 &&
                        otherPlaceholdersDetails.length > 0 &&
                        otherPlaceholdersDetails.map((list) => {
                          if (list && list.type === "Applicants") {
                            return <CustomFieldsByModule data={list} />;
                          }
                        })}
                    </>
                  ) : (
                    " "
                  )}

                  <Dialog
                    open={openApplicantsModal}
                    onClose={() => setOpenApplicantsModal(false)}
                    maxWidth="lg"
                    fullWidth
                    disableRestoreFocus={true}
                    disableScrollLock={true}
                  >
                    <DialogTitle
                      sx={{
                        backgroundColor: "var(--secondary-bg-color)",
                        color: "var(--secondary-background-text-color)",
                        textAlign: "center",
                        fontWeight: 600,
                        position: "relative",
                      }}
                    >
                      Applicant Information
                      <span
                        style={{
                          position: "absolute",
                          right: 20,
                          top: 15,
                          cursor: "pointer",
                          color: "red",
                          fontSize: "18px",
                        }}
                        onClick={() => setOpenApplicantsModal(false)}
                      >
                        ✕
                      </span>
                    </DialogTitle>

                    <DialogContent sx={{ padding: 3 }}>
                      {tableData && tableData.length > 0 && (
                        <div className="emailBody-table">
                          <DynamicTable
                            config={configuration}
                            data={tableData}
                            colmns={tableColumnData}
                            actionDropdown={[]}
                            actions={{}}
                            addModel={addNewModel}
                            searchKeyWord=""
                            noDataText=""
                          />
                        </div>
                      )}
                    </DialogContent>
                  </Dialog>
                </table>

                {templateCustomKeys && templateCustomKeys.length > 0 && (
                  <p className="customheading">Custom Fields</p>
                )}
                <table className="emailkeys">
                  {/* style={{ maxHeight: "180px", overflow: "auto" }} */}
                  {templateCustomKeys &&
                    templateCustomKeys.map((list) => (
                      <tr>
                        {/* <td></td> */}
                        <td width="200px">
                          <span style={{ wordBreak: "break-all" }}>
                            {list.name}
                          </span>
                        </td>
                        <td width="30px" align="center">
                          :
                        </td>
                        <td width="400px">
                          <TextField
                            id="outlined-basic"
                            size="small"
                            variant="outlined"
                            name={list.name}
                            value={list.value}
                            onChange={(e) => {
                              onCustomfieldHandler(e.target.value, list);
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  {/* <tr>
                    <td width="200px" style={{ paddingTop: "10px" }}>
                      E-mail me a copy
                    </td>
                    <td
                      width="30px"
                      align="center"
                      style={{ paddingTop: "10px" }}
                    >
                      :
                    </td>
                    <td width="400px" style={{ paddingTop: "10px" }}>
                      <RadioGroup
                        style={{ marginLeft: "10px", gap: "5px" }}
                        row
                        id="editRadiobtn"
                        value={ccList}
                        onChange={(e) => setCCList(e.target.value)}
                      >
                        {mailmeArray.map((list) => (
                          <FormControlLabel
                            key={list.name}
                            value={list.name}
                            control={<Radio size="small" />}
                            label={list.name}
                          />
                        ))}
                      </RadioGroup>
                    </td>
                  </tr> */}
                </table>
                
            <div style={{ width: "100%", marginTop: "20px" }}>
            <Autocomplete
              multiple
              freeSolo
              readOnly
              disableClearable
              forcePopupIcon={false}
              options={[]}
              value={selectedTo}
                renderTags={(value, getTagProps) => {
                  const limit = 2;
                  const realTags = value.filter((v) => v);
                  const numTags = realTags.length;
                  const tags = realTags.slice(0, limit).map((option, index) => {
                    const { onDelete, ...tagProps } = getTagProps({ index });
                    return (
                      <Chip
                        key={index}
                        variant="filled"
                        label={option}
                        {...tagProps}
                        sx={{
                          backgroundColor: "#f5f5f5",
                          borderRadius: "4px",
                          fontWeight: 500,
                        }}
                      />
                    );
                  });
                  if (numTags > limit) {
                    tags.push(
                      <span
                        key="more"
                        style={{
                          marginLeft: "4px",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#000",
                        }}
                      >
                        +{numTags - limit}
                      </span>
                    );
                  }
                  return tags;
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="To"
                    placeholder={
                      selectedTo.length === 0
                        ? currentTo === "clients"
                          ? "Select hiring manager"
                          : "Add emails"
                        : ""
                    }
                    InputLabelProps={{
                      shrink: true,
                      className: "boldSelectlabel",
                    }}
                    InputProps={{
                      ...params.InputProps,
                      sx: {
                        height: "3.5rem",
                        "& .MuiAutocomplete-inputRoot": {
                          flexWrap: "nowrap !important",
                          alignItems: "center",
                        },
                        overflow: "hidden",
                        pr: "135px !important",
                        "& fieldset": {
                          borderColor: "#e0e0e0 !important",
                        },
                        "&:hover fieldset": {
                          borderColor: "#e0e0e0 !important",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#e0e0e0 !important",
                        },
                      },
                      endAdornment: (
                        <>
                          {selectedTo.length > 2 && (
                            <InputAdornment
                              position="end"
                              sx={{ position: "absolute", right: "12px" }}
                            >
                              <span
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                  color: "#000",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  setPopupType("Applicants");
                                  setOpenPreview(true);
                                }}
                              >
                                View all Applicants
                              </span>
                            </InputAdornment>
                          )}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
            />
            {!showCcField && (
              <div style={{ textAlign: "right", marginTop: "8px" }}>
                <span
                  style={{
                    cursor: "pointer",
                    color: "#000000ff",
                    fontSize: "14px",
                    fontWeight: 600,
                    textDecoration: "underline",
                  }}
                  onClick={() => setShowCcField(true)}
                >
                  + Add Cc
                </span>
              </div>
            )}
          </div>

          {showCcField && (
            <div style={{ width: "100%", marginTop: "20px" }}>
              <Autocomplete
                multiple
                disableCloseOnSelect
                disableClearable
                onOpen={() => {
                  document.body.classList.add("autocomplete-dropdown-open");
                }}
                onClose={() => {
                  document.body.classList.remove("autocomplete-dropdown-open");
                }}
                options={ccOptions}
                groupBy={(option) => option.group}
                ListboxProps={{
                  sx: {
                    padding: 0,
                  },
                }}
                renderGroup={(params) => (
                  <li key={params.key}>
                    <ListSubheader
                      style={{
                        fontWeight: "bold",
                        color: "var(--primary-color)",
                        lineHeight: "30px",
                        fontSize: "16px",
                        backgroundColor: "white", // Ensure background is solid when sticky
                      }}
                    >
                      {params.group}
                    </ListSubheader>
                    <ul style={{ padding: 0 }}>{params.children}</ul>
                  </li>
                )}
                getOptionLabel={(option) =>
                  typeof option === "string" ? option : option.label || ""
                }
                value={selectedCc.map((email) => {
                  const found = ccOptions.find((o) => o.value === email);
                  return found ? found : email;
                })}
                onChange={(event, newValue) => {
                  const emails = newValue.map((item) =>
                    typeof item === "string" ? item : item.value,
                  );
                  setSelectedCc(emails);
                }}
                renderTags={(value, getTagProps) => {
                  const limit = 2;
                  const realTags = value.filter((v) => v);
                  const numTags = realTags.length;
                  const tags = realTags.slice(0, limit).map((option, index) => {
                    const label =
                      typeof option === "string" ? option : option.label;
                    return (
                      <Chip
                        key={index}
                        variant="filled"
                        label={label}
                        {...getTagProps({ index })}
                        sx={{
                          backgroundColor: "#f5f5f5",
                          borderRadius: "4px",
                          fontWeight: 500,
                        }}
                      />
                    );
                  });
                  if (numTags > limit) {
                    tags.push(
                      <span
                        key="more"
                        style={{
                          marginLeft: "4px",
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#000",
                        }}
                      >
                        +{numTags - limit}
                      </span>
                    );
                  }
                  return tags;
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Cc"
                    placeholder="Select"
                    InputLabelProps={{
                      shrink: true,
                      className: "boldSelectlabel",
                    }}
                      inputProps={{
                        ...params.inputProps,
                        readOnly: true,
                        placeholder: "Select",
                        style: {
                          ...params.inputProps.style,
                          minWidth: "40px",
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        sx: {
                          ...params.InputProps.sx,
                          height: "3.5rem",
                          "& .MuiAutocomplete-inputRoot": {
                            flexWrap: "nowrap !important",
                            alignItems: "center",
                          },
                          overflow: "hidden",
                          pr: "155px !important",
                        },
                        endAdornment: (
                          <>
                            {selectedCc.length >= 1 && (
                              <InputAdornment
                                position="end"
                                sx={{ position: "absolute", right: "32px" }}
                              >
                                <span
                                  style={{
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                    color: "#000",
                                    marginRight: '30px'
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    setPopupType("CcUsers");
                                    setOpenPreview(true);
                                  }}
                                >
                                  View all CC'd Users
                                </span>
                              </InputAdornment>
                            )}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                  />
                )}
              />
            </div>
          )}

              </div>

            </>
          ) : (
            ""
          )}
        </div>
      

          {mailTemplate ? (
            <>
              <div style={{ height: "60px" }}></div>
              <div className="footer_btn">
                <ApplicantsFooter
                  onReceiveProps={(e, type) => {
                    footerHandler(e, type);
                  }}
                  isEnableAssociateJob={isGenerateTemp}
                  component={"generateMail"} // generateMail
                />
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      ) : (
        <h1
          style={{
            fontWeight: 300,
            lineHeight: 1.2,
            textAlign: "center",
            margin: "60px 0",
            fontSize: "3rem",
          }}
        >
          No email templates found
        </h1>
      )}
      <Dialog
        open={openPreview}
        onClose={() => {
          setOpenPreview(false);
        }}
        TransitionProps={{
          onExited: () => {
            setPopupType("");
          },
        }}
        maxWidth={popupType === "Template" ? "md" : (popupType === "CcUsers" || popupType === "Applicants") ? "sm" : "lg"}
        fullWidth
        disableRestoreFocus={true}
        disableScrollLock={true}
      >
        <DialogTitle
          style={{
            backgroundColor: "var(--secondary-bg-color)",
            color: "var(--secondary-background-text-color)",
            fontWeight: 600,
          }}
        >
          {popupType === "Template"
            ? "Template Preview"
            : popupType === "Applicants"
              ? "Applicants"
              : popupType === "CcUsers"
                ? "CC'd Users"
                : ""}
          <span
            onClick={() => {
              setOpenPreview(false);
            }}
            style={{ float: "right", cursor: "pointer" }}
          >
            <img
              src={process.env.PUBLIC_URL + "/assests/img/close.svg"}
              alt=""
              width={16}
              height={16}
            />
          </span>
        </DialogTitle>
        <DialogContent dividers>
          {popupType === "Template" && (
            <div
              dangerouslySetInnerHTML={{
                __html: selectedTemplateResponse?.[0]?.emailBody,
              }}
            />
          )}
          {(popupType === "Applicants" || popupType === "CcUsers") && (
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  popupType === "CcUsers" || popupType === "Applicants"
                    ? "repeat(2, minmax(0, 1fr))"
                    : "repeat(auto-fill, minmax(300px, 1fr))",
                gap: "20px",
                padding: "10px",
                maxHeight: "60vh",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              {(popupType === "Applicants" ? selectedTo : selectedCc).map(
                (email, index) => {
                  const name = getNameFromEmail(email);
                  const foundCc = popupType === "CcUsers" ? ccOptions.find((item) => item.value === email) : null;
                  const group = foundCc?.group;
                  return (
                    <div key={index}>
                      {name && (
                        <p
                          style={{
                            fontWeight: "bold",
                            marginBottom: group ? "2px" : "8px",
                            fontSize: "16px",
                          }}
                        >
                          {name}
                        </p>
                      )}
                      {group && (
                        <p
                          style={{
                            color: "gray",
                            fontSize: "14px",
                            marginBottom: "8px",
                          }}
                        >
                          {group}
                        </p>
                      )}
                      <Chip
                        label={email}
                        variant="filled"
                        sx={{
                          backgroundColor: "#f5f5f5",
                          borderRadius: "8px",
                          height: "auto",
                          minHeight: "40px",
                          fontSize: "14px",
                          px: 1,
                          maxWidth: "100%",
                          "& .MuiChip-label": {
                            display: "block",
                            whiteSpace: "normal",
                            wordBreak: "break-all",
                            padding: "8px 4px",
                          },
                        }}
                      />
                    </div>
                  );
                },
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default GenerateTemplateNew;

// for dynamic Table config Object
const configuration = {
  isSearchbar: false,
  isPaging: true,
  isDropdownActions: false,
  isCheckbox: false,
  isActions: false,
  recordperPage: 10,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: false,
  totalRecordsCount: 0,
  totalRecordsCountText: "",
  limitData: 10,
  isCheckAlignRight: false,
  isPaginationTop: false,
  isSearchServer: false,
  isPagingServer: false,
  isPageRange: false,
};

const addNewModel = {
  url: "",
  displayName: "",
};
